export const handleButton = () => {
  window.location.reload();
};
